import React from 'react'
import { useTranslation } from 'react-i18next'

import dompurify from 'dompurify'

import * as styles from './Activity.module.scss'

import { HotelDetail } from '../../../../apis/fvillage'
import { getPublication } from '../../../../hooks'
import { Button, Flex, FlexBox, Text } from '../../../basics'

type ActivityProps = {
  activities: HotelDetail[]
}

const translateNamespace = 'components.Activity'

export const Activity: React.FC<ActivityProps> = ({ activities }) => {
  const { t, i18n } = useTranslation()

  return (
    <div className={styles.activityContainer}>
      <h2>{t(`${translateNamespace}.title`)}</h2>

      <div className={styles.activityContent}>
        {activities.map(({ images, publications }, index) => {
          const publication = getPublication(i18n.language, publications ?? [])
          const viewMoreUrl = publication?.url
          return (
            // eslint-disable-next-line react/no-array-index-key
            <Flex key={index} optionClass={styles.activityContainerRow}>
              <img src={images?.length ? images[0].url : ''} alt="facility" />

              <Flex optionClass={styles.activityDetail}>
                <FlexBox>
                  <Text pcSize={24} spSize={18} weight="bold">
                    {publication?.name}
                  </Text>
                  <div className={styles.rowGap} />
                  <Text pcSize={16} spSize={14}>
                    <div
                      // eslint-disable-next-line react/no-danger
                      dangerouslySetInnerHTML={{
                        __html: dompurify.sanitize(
                          publication?.description ?? '',
                          {
                            ADD_ATTR: ['target'],
                          }
                        ),
                      }}
                    />
                  </Text>
                </FlexBox>
                {viewMoreUrl && (
                  <FlexBox optionClass={styles.activityDetailButton}>
                    <a
                      href={viewMoreUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <Button htmlType="button" variant="primary" bold outline>
                        {t(`${translateNamespace}.viewMore`)}
                        <span className={styles.arrowRight} />
                      </Button>
                    </a>
                  </FlexBox>
                )}
              </Flex>
            </Flex>
          )
        })}
      </div>
    </div>
  )
}
